import { render, staticRenderFns } from "./DetailCreditProvider.vue?vue&type=template&id=1dfdc80d"
import script from "./DetailCreditProvider.vue?vue&type=script&lang=js"
export * from "./DetailCreditProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports